/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 打卡/印花活动浏览临时接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  request: member.BrowseTaskRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.BrowseTaskRpcResponse;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/browse`,
    data: request,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
